import React, { useEffect, useState } from "react";
import Card from "./components/card/Card";
import "./home.scss";
import FormTitle from "./components/formTitle/FormTitle";
import ModalDialog from "./components/modal/ModalDialog";

let formName = [
  {
    name: "TT Check Socket",
    to: "ttchecksocket",
    isBilateral: true,
  },
  {
    name: "TF Check Socket",
    to: "tfchecksocket",
    isBilateral: true,
  },
  /*{ //Temporarily hidden
    name: "WillowWood Core™ TT with RevoFit",
    to: "ttstandardrevo",
  },
  {
    name: "WillowWood Core™ TF with RevoFit",
    to: "tfstandardrevo",
  },*/
  {
    name: "TT Definitive Socket",
    to: "ttdefinitive",
    isBilateral: true,
  },
  {
    name: "TF Definitive Socket",
    to: "tfdefinitive",
    isBilateral: true,
  },
  /*{ //Temporarily hidden
    name: "TT One® Socket",
    to: "ttonesocket",
  },
  {
    name: "TF One® Socket",
    to: "tfonesocket",
  },*/
  {
    name: "Xtremity TT Socket",
    to: "ttxtremity",
    isBilateral: false,
  },
  // { //Temporarily hidden
  //   name: "Knee Bundle",
  //   to: "kneebundle",
  //   isBilateral: false,
  // },
  {
    name: "Liners",
    to: "liners",
    isBilateral: false,
  },
  {
    name: "Feet",
    to: "feet",
    isBilateral: false,
  },
  {
    name: "Design Liners",
    to: "designliners",
    isBilateral: true,
  }
];

const Home = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("TT check socket");
  const [to, setTo] = useState("");

  const [value, setValue] = useState("2");
  const [isBilateral,setIsBilateral] = useState(false);

  let accountNumber = localStorage.getItem("accountNumber");
  if (accountNumber !== "11111") {
    formName = formName.filter(fn => fn.name !== "Design Liners")
  } else {
    localStorage.setItem("parentAccount", "11111");
  }

  const parentAccount = localStorage.getItem("parentAccount");
  const doesDesignLinerExist = formName.some(fn => fn.name === "Design Liners");
  if (parentAccount !== null && parentAccount === "11111" && !doesDesignLinerExist) {
    localStorage.setItem("accountNumber", "11111");
    window.location.reload()
  }

  const handleChange = (event, selected) => {
    setValue(event.target.value);
    if (to.includes("-")) {
      const parts = to.split("-");
      const updatedString = parts[0] + "-" + event.target.value;
      setTo(updatedString);
    } else {
      setTo(to + "-" + event.target.value);
    }
    // setSelectedForms(selected);
  };

  const handleChangeOff = (value) => {
    setTo(value);
  };

  const handleClickOpen = (name, to,isBilateral) => {
    setTitle(name);
    setOpen(true);
    setTo(to);
    setIsBilateral(isBilateral)
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="">
        <div className="formCardWrapper">
          <FormTitle
            title="Order Forms for Custom Products"
            description="For your convenience, all WillowWood custom product order forms are listed below. "
          />
          <div className="formSelectCard">
            {formName.map((name) => (
              <Card
                key={name.name}
                formTitle={name.name}
                handleClickOpen={() => handleClickOpen(name.name, name.to, name.isBilateral)}
              />
            ))}
          </div>

          <div className="cardModal">
            <ModalDialog
              open={open}
              formTitle={title}
              handleClose={handleClose}
              to={to}
              value={value}
              handleChange={handleChange}
              isBilateral={isBilateral}
              handleChangeOff={handleChangeOff}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
